export const Config = {
  apiUrl: 'https://api.servispozitif.com/api/',
  //apiUrl:'http://localhost:22900/api/',
  //kurumid: 21545, //prod
  kurumid: 21777, //test
  production: true,
  isontalepgoster: true,
  istalepgoster: true,
  isMusteriOlusur: true,
  isCihazZorunlu: true,
  isTalepolustur: true,
  logintitle : "Talep Sistemi - Erizz",
  logo: "logo.jpeg",
  footer1: "Erizz - Tüm hakları saklıdır. 2025 ",
  footer2: ""
};